/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
// import { he, en, ar } from 'vuetify/locale'
// import heI18n from '@/lang/he'
import * as labs from 'vuetify/labs/components'

// Dates
// import DateFnsAdapter from '@date-io/date-fns'
// import LuxonAdapter from '@date-io/luxon'
// import heIS from 'date-fns/locale/he'
import { aliases, mdi } from 'vuetify/iconsets/mdi' // Example: MDI Icons

import he from 'vuetify/lib/locale/he'
import en from 'vuetify/lib/locale/en'
import ar from 'vuetify/lib/locale/ar'
import { getCurrentLocale } from './i18n'

export const lightColors = {
  primary: '#2196F3',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  vividSkyBlue: '#37a8ff',
  success: '#4CAF50',
  warning: '#F39c11',
  warningError: '#ffb201',
  lightGrey: '#b8b7b7',
  blueText: '#1F2D37',
  aliceBlue: '#E5F4FF',
  text: '#1f2d37', // Custom global te
}

// const luxon = new LuxonAdapter({ locale: 'he', formats: 'keyboardDateTime' })
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  // date: {
  //   adapter: DateFnsAdapter,
  //   locale: {
  //     he: heIS,
  //   },
  // },
  locale: {
    locale: getCurrentLocale(),
    fallback: 'he',
    messages: { he, en, ar },
    rtl: { he: true, en: false, ar: true },
  },
  components: {
    ...labs,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    themes: {
      light: {
        colors: lightColors,
      },
    },
  },
})

// export default new Vuetify({
//   rtl: true,
//   lang: {
//     locales: { he, en, ar },
//     current: getCurrentLocale(),
//   },
//   defaultAssets: {
//     font: {
//       family: 'Fredoka',
//     },
//   },
//   theme: {
//     options: {
//       customProperties: true,
//     },
//     themes: {
//       light: {
//         primary: '#2196F3',
//         secondary: '#424242',
//         accent: '#82B1FF',
//         error: '#FF5252',
//         info: '#2196F3',
//         success: '#4CAF50',
//         warning: '#F39c11',
//         warningError: '#ffb201',
//         lightGrey: '#b8b7b7',
//         blueText: '#1F2D37',
//         aliceBlue: '#E5F4FF',
//         text: '#1f2d37', // Custom global text color
//       },
//     },
//   },
// })
